import { Input, InputProps } from 'antd'
import cls from 'classnames'
import styles from './AInput.module.less'

const COMPONENT_NAME = 'A-Input'

type Props = Pick<
  InputProps,
  | 'placeholder'
  | 'defaultValue'
  | 'value'
  | 'className'
  | 'allowClear'
  | 'onBlur'
  | 'onChange'
  | 'onClear'
  | 'onKeyDown'
  | 'onClick'
  | 'maxLength'
  | 'showCount'
  | 'disabled'
> & {}

type AInputProps = Props & {
  testId?: string
}

function AInput(props: AInputProps) {
  const { testId, className, ...inputProps } = props
  const classNames = cls(styles[COMPONENT_NAME], className)
  return <Input {...inputProps} data-testid={testId} className={classNames} />
}

export default AInput
